import {
  dispatcher,
  api,
  RESOURCE_FETCH,
  RESOURCE_GET_TO_EDIT
} from '@unicus/react-ui-kit';

export const FINANCIALENTRY = 'FINANCIALENTRY';

export const FINANCIALENTRY_POST = 'FINANCIALENTRY_POST';
export const FINANCIALENTRY_POST_FINISHED = 'FINANCIALENTRY_POST_FINISHED';

export const FINANCIALENTRY_GET = 'FINANCIALENTRY_GET';
export const FINANCIALENTRY_GET_FINISHED = 'FINANCIALENTRY_GET_FINISHED';

export const FINANCIALENTRY_CLOSE_CONFIRM_PAYMENT =
  'FINANCIALENTRY_CLOSE_CONFIRM_PAYMENT';

export const FINANCIALENTRY_OPEN_INVOICE = 'FINANCIALENTRY_OPEN_INVOICE';
export const FINANCIALENTRY_OPEN_INVOICE_FINISHED =
  'FINANCIALENTRY_OPEN_INVOICE_FINISHED';
export const FINANCIALENTRY_CLOSE_INVOICE = 'FINANCIALENTRY_CLOSE_INVOICE';

export const FINANCIALENTRY_CANCEL_INVOICE = 'FINANCIALENTRY_CANCEL_INVOICE';
export const FINANCIALENTRY_CANCEL_INVOICE_FINISHED =
  'FINANCIALENTRY_CANCEL_INVOICE_FINISHED';

export const FINANCIALENTRY_REFRESH = 'FINANCIALENTRY_REFRESH';

export const FINANCIALENTRY_OPEN_RESEND_EMAIL_INVOICE =
  'FINANCIALENTRY_OPEN_RESEND_EMAIL_INVOICE';
export const FINANCIALENTRY_CLOSE_RESEND_EMAIL_INVOICE =
  'FINANCIALENTRY_CLOSE_RESEND_EMAIL_INVOICE';

export const FINANCIALENTRY_RESEND_EMAIL_INVOICE =
  'FINANCIALENTRY_RESEND_EMAIL_INVOICE';
export const FINANCIALENTRY_RESEND_EMAIL_INVOICE_FINISHED =
  'FINANCIALENTRY_RESEND_EMAIL_INVOICE_FINISHED';

export const FINANCIALENTRY_OPEN_DETAIL = 'FINANCIALENTRY_OPEN_DETAIL';
export const FINANCIALENTRY_OPEN_DETAIL_FINISHED =
  'FINANCIALENTRY_OPEN_DETAIL_FINISHED';

export const FINANCIALENTRY_DELETE = 'FINANCIALENTRY_DELETE';
export const FINANCIALENTRY_DELETE_FINISHED = 'FINANCIALENTRY_DELETE_FINISHED';

export const FINANCIALENTRY_EXPORT = 'FINANCIALENTRY_EXPORT';
export const FINANCIALENTRY_EXPORT_FINISHED = 'FINANCIALENTRY_EXPORT_FINISHED';

export const FINANCIALENTRY_CHANGE_TO_EXPORT =
  'FINANCIALENTRY_CHANGE_TO_EXPORT';
export const FINANCIALENTRY_CHANGE_TO_EXPORT_FINISHED =
  'FINANCIALENTRY_CHANGE_TO_EXPORT_FINISHED';

export const FINANCIALENTRY_SYNC_INVOICE = 'FINANCIALENTRY_SYNC_INVOICE';
export const FINANCIALENTRY_SYNC_INVOICE_FINISHED =
  'FINANCIALENTRY_SYNC_INVOICE_FINISHED';

export const FINANCIALENTRY_CLOSE_DETAIL = 'FINANCIALENTRY_CLOSE_DETAIL';

export const FINANCIALENTRY_EXPORT_CSV = 'FINANCIALENTRY_EXPORT_CSV';
export const FINANCIALENTRY_EXPORT_CSV_FINISHED =
  'FINANCIALENTRY_EXPORT_CSV_FINISHED';

export const FINANCIALENTRY_OPEN_TRANSFER = 'FINANCIALENTRY_OPEN_TRANSFER';
export const FINANCIALENTRY_CLOSE_TRANSFER = 'FINANCIALENTRY_CLOSE_TRANSFER';

export const FINANCIALENTRY_CREATE_TRANSFER = 'FINANCIALENTRY_CREATE_TRANSFER';
export const FINANCIALENTRY_CREATE_TRANSFER_FINISHED =
  'FINANCIALENTRY_CREATE_TRANSFER_FINISHED';

export const FINANCIALENTRY_DELETE_TRANSFER = 'FINANCIALENTRY_DELETE_TRANSFER';
export const FINANCIALENTRY_DELETE_TRANSFER_FINISHED =
  'FINANCIALENTRY_DELETE_TRANSFER_FINISHED';

export const FINANCIALENTRY_CASH_FLOW = 'FINANCIALENTRY_CASH_FLOW';
export const FINANCIALENTRY_CASH_FLOW_FINISHED =
  'FINANCIALENTRY_CASH_FLOW_FINISHED';

export const FINANCIALENTRY_CASH_BOOK = 'FINANCIALENTRY_CASH_BOOK';
export const FINANCIALENTRY_CASH_BOOK_FINISHED =
  'FINANCIALENTRY_CASH_BOOK_FINISHED';

export const FINANCIALENTRY_CASH_BOOK_UNLOAD =
  'FINANCIALENTRY_CASH_BOOK_UNLOAD';

export const create = (data, onSuccess, tenant) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    payload: data,
    actionType: FINANCIALENTRY_POST,
    effect: async () => api.post('financial-entries', data, tenant),
    onSuccess
  });
};

export const createByEvent = (id, data, onSuccess, tenant) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    payload: data,
    actionType: FINANCIALENTRY_POST,
    effect: async () =>
      api.post(`events/${id}/financial-entries`, data, tenant),
    onSuccess
  });
};

export const update = (data, onSuccess, tenant) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    payload: data,
    actionType: FINANCIALENTRY_POST,
    effect: async () => api.put(`financial-entries/${data.id}`, data, tenant),
    onSuccess
  });
};

export const fetch = (resource, params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: RESOURCE_FETCH,
    effect: async () =>
      api.fetch('financial-entries/financial-entry-item-with-summary', params)
  });
};

export const get = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: RESOURCE_GET_TO_EDIT,
    effect: async () => api.get('financial-entries', id),
    onSuccess
  });
};

export const closeConfirmPayment = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      FINANCIALENTRY_CLOSE_CONFIRM_PAYMENT,
      'financial-entries'
    )
  );
};

export const editInvoice = (financialEntryId) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_OPEN_INVOICE,
    effect: async () => api.get('financial-entries', financialEntryId)
  });
};

export const cancelEditInvoice = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(FINANCIALENTRY_CLOSE_INVOICE, 'financial-entries')
  );
};

export const cancelInvoice = (financialEntryId, internalCancel) => async (
  dispatch
) => {
  const route = !internalCancel ? `invoice` : 'internal-invoice';

  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_CANCEL_INVOICE,
    effect: async () =>
      api.del('financial-entries', `${financialEntryId}/${route}`)
  });
};

export const refresh = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(FINANCIALENTRY_REFRESH, 'financial-entries')
  );
};

export const openResendInvoice = (data) => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      FINANCIALENTRY_OPEN_RESEND_EMAIL_INVOICE,
      'financial-entries',
      data
    )
  );
};

export const closeResendInvoice = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      FINANCIALENTRY_CLOSE_RESEND_EMAIL_INVOICE,
      'financial-entries'
    )
  );
};

export const postResendInvoice = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_RESEND_EMAIL_INVOICE,
    effect: async () => api.post('invoices/resend-email', data),
    onSuccess
  });
};

export const openViewDetail = (financialEntryId) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_OPEN_DETAIL,
    effect: async () =>
      api.get('financial-entries', `${financialEntryId}/detail`)
  });
};

export const closeViewDetail = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(FINANCIALENTRY_CLOSE_DETAIL, 'financial-entries')
  );
};

export const remove = (id) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_DELETE,
    effect: async () => api.del('financial-entries', id)
  });
};

export const exportFetch = (params, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_EXPORT,
    effect: async () =>
      api.fetch('financial-entries/accountants/export', params),
    onSuccess
  });
};

export const changeExport = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_CHANGE_TO_EXPORT,
    effect: async () => api.post('financial-entries/change-export', data),
    onSuccess
  });
};

export const syncInvoice = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_SYNC_INVOICE,
    effect: async () => api.post(`invoices/${id}/integration-sync`),
    onSuccess
  });
};

export const createFileExport = (querySearch, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_EXPORT_CSV,
    effect: async () =>
      api.post(`financial-entries/file-export?${querySearch}`),
    onSuccess
  });
};

export const openTransfer = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(FINANCIALENTRY_OPEN_TRANSFER, 'financial-entries')
  );
};

export const closeTransfer = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(FINANCIALENTRY_CLOSE_TRANSFER, 'financial-entries')
  );
};

export const createTransfer = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_CREATE_TRANSFER,
    effect: async () => api.post(`financial-entries/transfer`, data),
    onSuccess
  });
};

export const deleteTransfer = (transactionId, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_DELETE_TRANSFER,
    effect: async () =>
      api.del('financial-entries', `transfer?transactionId=${transactionId}`),
    onSuccess
  });
};

export const getCashFlow = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_CASH_FLOW,
    effect: async () => api.fetch('financial-entries/cash-flow', params)
  });
};

export const getCashBook = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financial-entries',
    actionType: FINANCIALENTRY_CASH_BOOK,
    effect: async () => api.fetch('financial-entries/cash-book', params)
  });
};

export const chashBookUnload = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      FINANCIALENTRY_CASH_BOOK_UNLOAD,
      'financial-entries'
    )
  );
};
